/* eslint-disable no-unused-vars */
/* eslint-disable import/no-unresolved */
const constants = require('../../constants');
const slickSlider = require('../../components/slider');
const utils = require('../../utils');

function slideToGoTo(element, slideToGo) {
    element.slick('slickGoTo', slideToGo);
}

const runSlick = (element) => {
    const docBody = $(document.body);
    const productGallery = $('#product-gallery');

    if (element.find('.carousel-item').length > 1) {
        const { prev, next } = utils.getSliderLabels();
        slickSlider.methods.useCustomizableSlick(
            element,
            true,
            `<button type="button" class="icon-left-arrow-line prev no-btn" aria-label="${prev}"></button>`,
            `<button type="button" class="icon-right-arrow-line next no-btn" aria-label="${next}"></button>`,
            1,
            {},
        );

        const slideIndexContainer = element.parents('.product-detail.product-wrapper').length <= 0
            && element.parents('.product-bundle.row-product-info').length
            ? element.parents('.product-bundle.row-product-info') : element.parents('.product-detail.product-wrapper');

        const indexToGo = (productGallery.hasClass('carousel-inner')
                || productGallery.parents('.modal').length
                || window.outerWidth < constants.viewport_bootstrap.lg)
                && slideIndexContainer.find('#product-gallery .slick-active').length
            ? slideIndexContainer.find('#product-gallery .slick-active').data('slick-index')
            : slideIndexContainer.find('#product-gallery .carousel-item.clicked').index();
        slideToGoTo(element, indexToGo);

        if (element.hasClass('slick-initialized')) {
            element.slick('refresh');
        }
    }

    if (window.outerWidth < constants.viewport_bootstrap.lg && $('.primary-images .carousel-inner').length <= 0) {
        const outerContent = element.find('.carousel-item');
        const innerContent = outerContent.find('img');

        outerContent.scrollLeft((innerContent.width() - outerContent.width()) / 2);

        element.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
            outerContent.scrollLeft((innerContent.width() - outerContent.width()) / 2);
        });
    }

    element.parents('.zoomCarousel').addClass('active');
    docBody.addClass('no-overflow');
};

// eslint-disable-next-line consistent-return
const checkElement = (selector, fn) => {
    if ($(selector).length) {
        fn();
        return;
    }
    setTimeout(() => {
        checkElement(selector, fn);
    }, 100);
};

const fullScreenGaleryZoom = () => {
    const docBody = $(document.body);
    docBody.on('click', '#product-gallery.full-screen-enabled .carousel-item', (e) => {
        e.preventDefault();
        const thisTarget = $(e.currentTarget);
        const parentTarget = thisTarget.parents('#product-gallery');

        $('#product-gallery.full-screen-enabled .carousel-item').not(thisTarget).removeClass('clicked');
        thisTarget.addClass('clicked');

        if (!parentTarget.find('.slick-current .video').length && !$('#Cart-Show').length && !$('#Wishlist-Show').length) {
            let productContainer = parentTarget.parents('.product-detail.product-wrapper');
            if (productContainer.length <= 0 && parentTarget.parents('.product-bundle.row-product-info').length) {
                productContainer = parentTarget.parents('.product-bundle.row-product-info');
            }
            const productSetWrapper = productContainer.parents('.product-set-detail');
            const isProductSet = productSetWrapper.length;
            const containerPID = isProductSet ? productSetWrapper.attr('data-pid') : productContainer.attr('data-pid');
            const containerProductID = productContainer.attr('data-productid');
            let modalContainer = productContainer.find(`#carouselProdViewModal-${containerPID}`).length ? productContainer.find(`#carouselProdViewModal-${containerPID}`) : productContainer.find(`#carouselProdViewModal-${containerProductID}`);

            if (!modalContainer.length) {
                modalContainer = productContainer.find('.zoomCarousel');
            }

            if (!modalContainer.hasClass('images-loaded')) {
                const carouselImages = modalContainer.find('.carousel-item img');
                carouselImages.each((index, image) => {
                    const currentTarget = $(image);
                    currentTarget.attr('src', currentTarget.attr('data-src'));
                });
            }

            modalContainer.addClass('images-loaded');
            modalContainer.modal('show');
            modalContainer.on('shown.bs.modal', () => {
                checkElement(modalContainer.find('.gallery-slider'), runSlick.bind(null, modalContainer.find('.gallery-slider')));
            });

            modalContainer.on('hidden.bs.modal', () => {
                $('.embed-responsive-item').attr('src', '');
                docBody.removeClass('no-overflow');
            });
        }
    });

    docBody.on('click', '.close-modal, .zoomCarousel .gallery-slider img', (e) => {
        const thisTarget = $(e.currentTarget);
        let thisParentWrapper = thisTarget.parents('.product-detail.product-wrapper');
        const productGallery = $('#product-gallery');

        if (thisParentWrapper.length <= 0 && thisTarget.parents('.product-bundle.row-product-info').length) {
            thisParentWrapper = thisTarget.parents('.product-bundle.row-product-info');
        }

        if (productGallery.hasClass('carousel-inner') || productGallery.parents('.modal').length) {
            slideToGoTo(thisParentWrapper.find('#product-gallery'), thisParentWrapper.find('.zoomCarousel .slick-slide.slick-active').data('slick-index'));
        }

        $('.zoomCarousel.show').modal('hide');
    });
};

export default () => {
    fullScreenGaleryZoom();
};
